export const removeRouterOutletsFromUrl = (url: string): string => {
  return url.replace(/\(.*?\)/g, '');
};
